import React from 'react'
import classNames from 'classnames'

import { StateProvider } from '../../core'

import './gallery.scss'


const GallerySection = ({ data = {} }) => {
  const { images } = data
  if (
    !images 
      || images.length === 0
  ) {
    return null
  }

  return (
    <StateProvider value={0}>{(activeIndex, setActiveIndex) => (
      <div styleName='gallery'>
        {images.map((image, i) => {
          const imageClass = classNames(
            'image',
            i === activeIndex && 'is-active'
          )

          return (
            <div 
              key={i}
              styleName={`${imageClass}`}
              style={{ backgroundImage: `url(${image.resize.src})`}}
            />
          )
        })}

        <div styleName='controls'>
          <div 
            styleName='left-control control'
            onClick={() => setActiveIndex((images.length + activeIndex - 1) % images.length)}
          >{'<-'}</div>
          <div styleName='display'>{activeIndex + 1} of {images.length}</div>
          <div 
            styleName='right-control control'
            onClick={() => setActiveIndex((images.length + activeIndex + 1) % images.length)}
          >{'->'}</div>
        </div>
      </div>
    )}</StateProvider>
  )
}

export default GallerySection